import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientGaming } from "@obg/gaming.config";
import { ConfigService } from "@obg/ngx.global";

import { LicenseGroups } from "../multi-game-launcher/multi-game-launcher.model";

import { PlayForFunOptions } from "./game-launcher.model";

@Injectable({
	providedIn: "root",
})
export class GameLauncherConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientGaming>) {}

	adobeFlashInstallUrl(): string {
		return this.configService.get(
			(x) => x.matGamingUi.gameLauncher.adobeFlashInstallUrl,
			"https://get.adobe.com/flashplayer/"
		);
	}

	isLicenseVisible(): boolean {
		return this.configService.get((x) => x.matGamingUi.gameLauncher.isLicenseVisible, false);
	}

	licenseGroups(): LicenseGroups[] {
		return this.configService.get((x) => x.matGamingUi.gameLauncher.licenseGroups, []) as LicenseGroups[];
	}

	isCasinoPlayForFunAllowed(isAuthenticated: boolean): boolean {
		return isAuthenticated
			? this.configService.get((x) => x.matGamingUi.gameLauncher.playForFunOptions!.casino!.loggedIn, true)
			: this.configService.get((x) => x.matGamingUi.gameLauncher.playForFunOptions!.casino!.loggedOut, true);
	}

	isLiveCasinoPlayForFunAllowed(isAuthenticated: boolean): boolean {
		return isAuthenticated
			? this.configService.get((x) => x.matGamingUi.gameLauncher.playForFunOptions!.liveCasino!.loggedIn, false)
			: this.configService.get((x) => x.matGamingUi.gameLauncher.playForFunOptions!.liveCasino!.loggedOut, false);
	}

	getGameFrameMinWidth(): number {
		return this.configService.get((x) => x.matGamingUi.gameLauncher.gameFrameMinWidth, 620);
	}

	getMultiGameEnabled(): boolean {
		return this.configService.get((x) => x.matGamingUi.gameLauncher.isMultiGameEnabled, false);
	}

	getPlayForFunOptions(): PlayForFunOptions {
		return this.configService.get((x) => x.gamingUi.gameLauncher.playForFunOptions, {
			loggedIn: true,
			loggedOut: true,
		});
	}

	getPrimaryVariantIdsWithDisabledPlayForFun(): string[] {
		return ["MegaMoolah", "megaMoolah_mobile", "majorMillions_mobile", "MajorMillions"];
	}

	getRootCollectionIdsWithDisabledPlayForFun(): string[] {
		return this.configService.get(
			(x) => x.gamingUi.gameLauncher.rootCollectionIdsWithDisabledPlayForFun,
			[
				"PokerSideGames",
				"LiveCasino",
				"Sportsbook",
				"PokerLobby",
				"SportsbookLobby",
				"KenoLobby",
				"MiniGamesLobby",
				"TableGamesLobby",
			]
		);
	}

	getStudiosWithDisabledPlayForFun(): string[] {
		return [];
	}

	isPlayForRealTextButtonEnabled(): boolean {
		return this.configService.get(
			(x) => x.matGamingUi.gameLauncher.gameThumbnailOptions!.casino!.isPlayForRealTextButtonEnabled,
			false
		);
	}

	isNavigateToGamePageEnabled(): boolean {
		return this.configService.get((x) => x.gamingUi.gameLauncher.isNavigateToGamePageEnabled, false);
	}

	isGameSessionInfoEnabled(): boolean {
		return this.configService.get((x) => x.gamingUi.gameLauncher.isGameSessionInfoEnabled, false);
	}

	shouldHideWithdrawButtonInGame(): boolean {
		return this.configService.get((x) => x.gamingUi.gameLauncher.hideWithdrawInGame, true);
	}

	getProvidersWithOwnGameHistory(): string[] {
		return ["Playtech", "Evolution", "GiocaOnline"];
	}
}
